export default __webpack_public_path__ + "static/media/rambouillet13.887e4c36.jpg";